import React, {FC} from 'react'

const PurchaseButton: FC = () => (
  <></>
)

export {PurchaseButton}
